// Component Name:  Orders component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date:
// Description: This component is to view all the transaction details, and to download the invoice and mail the invoice.
// Dependencies: React,  Redux , API layer to fetch transaction
// Interfaces: Accepts props including selectedChargerId,locationData,user, toast messages
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [] Integrated API to fetch the transaction, download invoice for each transaction.
// [] Implemented filter transaction feature (paid, refund and onGoing).
// [] Implemented search functionality.
// [29-04-2025] Integrated a loading spinner to display while the invoice is being generated or downloaded.
import React, { Component } from "react";
import { Container, Card, CardBody, Row, Col, Nav, NavItem, NavLink, UncontrolledTooltip, Input, Label, Button, FormGroup } from "reactstrap";
import classnames from "classnames";
import { MDBDataTable } from "mdbreact";
import "./datatables.scss";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getTransactionByOwnerId } from "../../api/transactionAPI";
import { downloadInvoiceInPDF, downloadReportInPDF, mailInvoicePDF } from "../../api/downloadInvoice";
import { chargerSelected } from "../../store/actions";
import { computeConsumption, computeDate, computePaymentStatus, computeTime, computeTotal, inputRequired } from "../Utility/utilsFunctions";
import { ChargerDiv, DivHoverEffect, modalStyle } from "../Utility/styleComponents";
import { connect } from "react-redux";
import Spinner from "../Utility/Spinner";
import Modal from "react-modal";
import { loadTransactions } from "../../api/utils/loadTransactions";
import LKDownloadImg from "../../assets/images/LK_Icons/LK_Download.svg";
import LKMailSendImg from "../../assets/images/LK_Icons/LK_Message Send.png";
import { warningToast } from "../../store/dbFilter/actions";
import { getUserByRFID } from "../../api/userAPI";
import ReactModal from "react-modal";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import { ActiveBtn, CancelBtn } from "../Utility/Button";
import DropDown from "../Utility/DropDown";
import { downloadData } from "../Dashboard/dbConstants";
// import * as XLSX from "xlsx";
class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Charger Management System", link: "#" },
        { title: "Transactions", link: "#" },
      ],
      activeTab: "1",
      transLog: [],
      filterTransLog: [],
      paidLog: [],
      refundLog: [],
      onGoingLog: [],
      isLoading: false,
      userId: "9847040400",
      syncIntervalId: "",
      isShowUserEmailModal: false,
      invoiceDetails: {},
      selectedUserId: "",
      selectedUserEmail: "",
      allTransactions: [],
      isReportDownload:false
    };
    this._isMounted = false;
    this.toggleTab = this.toggleTab.bind(this);
    this.memoizedData = null;
    this.lastRows = null;

    this.closeIsShowUserEmailModal = this.closeIsShowUserEmailModal.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      let filteredData = [];

      if (tab === "1") {
        // All Orders Tab
        filteredData = this.state.transLog;
      } else if (tab === "2") {
        // Paid Tab
        filteredData = this.state.paidLog;
      } else if (tab === "3") {
        // Refund Tab
        filteredData = this.state.refundLog;
      } else if (tab === "4") {
        // OnGoing Tab
        filteredData = this.state.onGoingLog;
      }
      // Set the active tab and apply the filter
      this._isMounted &&
        this.setState({
          activeTab: tab,
          filterTransLog: filteredData,
        });
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    Modal.setAppElement("#root");
    /* if (this.props.selectedChargerId != null) {
            if (this.state.chargerId !== this.props.selectedChargerId) {
                this.setState({ chargerId: this.props.selectedChargerId, transLog: [] });


                console.log("Update ChargerId", this.state.chargerId);
            }
        } */
    document.getElementsByClassName("pagination")[0].classList.add("pagination-rounded");

    try {
      //await this.updateUserDetails(this.state.userId);
      this._isMounted && this.setState({ isLoading: true });
      const charger_status = await this.updateUserTransactions(this.state.userId);
      this._isMounted && this.setState({ isLoading: false });
    } catch (e) {
      console.log("Charger Details Update Error", e.toString());
    }

    const intervalId = setInterval(async () => {
      try {
        //console.log("Charger Update Routine");

        await this.updateUserTransactions(this.state.userId);
      } catch (e) {
        console.log("Charger Details Update Error", e.toString());
      }
    }, 5000);

    this._isMounted && this.setState({ syncIntervalId: intervalId });

    /* socket = io("https://backend.iqlabs.io:3000");


        socket.on("connect", () => {
            console.log("Socket Connection Successful");

            console.log("Response Topic", this.getResponseTopic(this.state.chargerId))

            socket.emit("subscribe", { topic: this.getResponseTopic(this.state.chargerId) });

            socket.on("mqtt", msg => {

                if (msg == null)
                    return;

                //console.log("Rx Msg", msg);
                const msgJson = JSON.parse(msg);
                const topic = msgJson.topic;
                const payload = JSON.parse(msgJson.payload);

                this.processMsg(payload);


            });

        });

        this.updateChargerImage(); */
  }

  async componentWillUnmount() {
    /*  console.log("Charger Page Exited");
 
         clearInterval(this.state.syncIntervalId);
 
         socket.emit("unsubscribe", { topic: this.getResponseTopic(this.state.chargerId) });
 
         socket.disconnect(); */
    this.setState({ transLog: [], filterTransLog: [] });
    this._isMounted = false;
    clearInterval(this.state.syncIntervalId);
  }

  handleDownloadInvoice = async (transactionData, userId) => {
    try {
      this._isMounted && this.setState({ isDownloadLoading: true });
      const { userPhNo = "", userEmail = "" } = await this.handleGetUserByRFID(userId);
      const invoiceData = {
        ...transactionData,
        phno: userPhNo,
        email: userEmail,
        serviceProvider: this.props.user.name || "",
        GST: this.props.user.gst || "",
        address: this.props.user.address || "",
        description: "Charging Session",
      };
      await downloadInvoiceInPDF(invoiceData);
    } catch (err) {
      console.log("Problem: ", err.problem, err.msg);
    } finally {
      this._isMounted && this.setState({ isDownloadLoading: false });
    }
  };

  handleGetUserByRFID = async (userId) => {
    try {
      const res = await getUserByRFID(userId);
      // console.log("res: userByRFID: ", res);
      const userPhNo = res?.data?.userDetails?.phoneNumber;
      const userEmail = res?.data?.userDetails?.email;

      return { userPhNo, userEmail };
    } catch (err) {
      console.log("Problem: ", err.problem, err.msg);
    }
  };

  handleMailInvoice = async () => {
    const { invoiceDetails, selectedUserId, selectedUserEmail } = this.state;
    try {
      this._isMounted && this.setState({ isDownloadLoading: true });

      console.log();
      const invoiceData = {
        ...invoiceDetails,
        phno: selectedUserId,
        email: selectedUserEmail,
        serviceProvider: this.props.user.name || "",
        GST: this.props.user.gst || "",
        address: this.props.user.address || "",
        description: "Charging Session",
      };
      await mailInvoicePDF(invoiceData);
    } catch (err) {
      console.log("Problem: ", err.problem, err.msg);
    } finally {
      this._isMounted && this.setState({ isDownloadLoading: false });
    }
  };

  handleClickOnMail = async (userId, data) => {
    try {
      const { userPhNo = "", userEmail = "" } = await this.handleGetUserByRFID(userId);
      this.setState({ invoiceDetails: data, selectedUserId: userPhNo, selectedUserEmail: userEmail, isShowUserEmailModal: true });
    } catch (err) {
      console.log("Problem: ", err.problem, err.msg);
    }
    // finally{
    //   this.setState({ invoiceDetails: data, selectedUserId: this.state.userPhNo? this.state.userPhNo:userId,  isShowUserEmailModal: true });
    // }
  };

  // to update the selected charger data
  selectCharger = (chargerId) => {
    if (chargerId === null) return;
    this.props.chargerSelected(chargerId);
  };

  // create transaction log table
  updateTransactionTable = (allTransactions) => {
    let trans_data = [];
    let ongoing_data = [];
    let paid_data = [];
    let refund_data = [];
    allTransactions.forEach((item, i) => {
      // the function generates the userid and invoice data onclick send mail/download pdf
      const onClickData = () => {
        if (isNaN(item.meterStop)) {
          this.props.warningToast({
            title: "Warning",
            message: "Cannot download Invoice for On-going transaction",
          });
          return;
        }
        const userId = item.userId || "";
        const data = {
          transactionId: item.transactionId,
          chargerId: item.chargerId,
          startTime: `${computeDate(item.startTime)}, ${computeTime(item.startTime)}`,
          endTime: `${computeDate(item.stopTime)}, ${computeTime(item.stopTime)}`,
          consumption: computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          price: item.perUnitRate,
        };
        return { userId, data };
      };
      trans_data.push({
        // checkbox: (
        //   <div className="custom-control custom-checkbox">
        //     <Input type="checkbox" className="custom-control-input" id="ordercheck1" />
        //     <Label className="custom-control-label" htmlFor="ordercheck1">
        //       &nbsp;
        //     </Label>
        //   </div>
        // ),
        id: item.chargerId,
        displayId: (
          <ChargerDiv
            key={item.chargerId}
            onClick={() => {
              console.log("item.chargerId: ", item.chargerId);
              this.selectCharger(item.chargerId);
              this.props.history.push("/cms-charger-detail");
            }}
          >
            {item.chargerId}
          </ChargerDiv>
        ),
        date: computeDate(item.startTime) + ", " + computeTime(item.startTime),
        userid: item.userId,
        transactionId: item.transactionId,
        conn: item.connectorId,
        kWh: computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
        total: computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10), item.perUnitRate),
        type: item.type,
        status: computePaymentStatus(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
        invoice: (
          <div style={{ display: "flex", gap: 20 }}>
            <div
              // color="light"
              onClick={async () => {
                const { userId = "", data = {} } = onClickData();
                await this.handleDownloadInvoice(data, userId);
              }}
            >
              {/* <i className="mdi mdi-download ml-2 "></i> */}
              <img src={LKDownloadImg} alt="downloadImg" style={{ width: "25px", height: "25px", cursor: "pointer" }} />
            </div>
            <div
              onClick={() => {
                const { userId = "", data = {} } = onClickData();
                this.handleClickOnMail(userId, data);
              }}
            >
              {/* <i className="ri-mail-line" style={{ fontSize: 20, cursor: "pointer" }}></i> */}
              <img src={LKMailSendImg} alt="mailImg" style={{ width: "35px", height: "35px", cursor: "pointer" }} />
            </div>
          </div>
        ),
      });

      if (isNaN(item?.meterStop)) {
        ongoing_data.push({ ...trans_data[i] });
      } else {
        paid_data.push({ ...trans_data[i] });
      }
    });

    if (JSON.stringify(trans_data) === JSON.stringify(this.state.transLog)) return;

    this._isMounted &&
      this.setState({
        transLog: trans_data,
        filterTransLog: trans_data,
        onGoingLog: ongoing_data,
        paidLog: paid_data,
      });

    console.log("filterOn going:ongoing_data ", ongoing_data);

    console.log(this.state.transLog);
    // this.filterTransaction();
    return;
  };

  updateUserTransactions = async () => {
    try {
      const allTransactions = await loadTransactions(this.props?.chargerIds);
      if (allTransactions == null) return;
      console.log("all Transactions: ", allTransactions);
      this.setState({ allTransactions: allTransactions });
      this.updateTransactionTable(allTransactions);
    } catch (err) {
      console.log("Error to retrive transaction by ownerId: ", err.msg);
    }
  };
  getMemoizedData() {
    const { filterTransLog } = this.state;

    // Only recompute if the rows have changed
    if (this.lastRows !== filterTransLog) {
      this.lastRows = filterTransLog;

      this.memoizedData = {
        columns: [
          { label: "Charger ID", field: "displayId", sort: "asc", width: 78 },
          { label: "Conn ID", field: "conn", sort: "asc", width: 28 },
          { label: "Date", field: "date", sort: "asc", width: 93 },
          { label: "User Id", field: "userid", sort: "asc", width: 109 },
          {
            label: "Transaction Id",
            field: "transactionId",
            sort: "asc",
            width: 90,
          },
          { label: "Type", field: "type", sort: "asc", width: 28 },
          { label: "Units", field: "kWh", sort: "asc", width: 28 },
          { label: "Total (₹)", field: "total", sort: "asc", width: 48 },
          { label: "Payment Status", field: "status", sort: "asc", width: 135 },
          { label: "Invoice", field: "invoice", sort: "asc", width: 110 },
        ],
        rows: filterTransLog,
      };
    }

    return this.memoizedData;
  }

  closeIsShowUserEmailModal() {
    this.setState({ isShowUserEmailModal: false, selectedUserEmail: "", selectedUserId: "", invoiceDetails: {} });
  }

  // to download the reports in PDF
  handleDownloadReportInPDF = async () => {
    const reportTitle = ["tar"];
    const chargerIds = this.props.chargerIds;
    const locationIds = this.props.locationIds;
    if (chargerIds.length === 0 || locationIds.length === 0) {
      warningToast({ title: "Warning", message: "There are no Transactions to download report" });
      return;
    }
    try {
      this.setState({ isDownloadLoading: true });
      const data = await downloadReportInPDF({ dateRange: [new Date("2024-01-01"), new Date()], chargerIds: chargerIds, locationIds: locationIds, reportTitle });
    } catch (e) {
      console.log("Error in downloading report", e);
    } finally {
      this.setState({ isDownloadLoading: false });
    }
  };

  // too download the report in excel
  // exportToExcel = () => {
  //   try {
  //     this.setState({ isDownloadLoading: true });
  //     if (this.state.allTransactions?.length === 0) {
  //       warningToast({ title: "Warning", message: "There are no Transactions to download report" });
  //       return;
  //     }
  //     // data parsing for the excel content
  //     const excelData = this.state.allTransactions?.map((item, index) => {
  //       const { chargerId, name, transactionId, perUnitRate } = item;
  //       return {
  //         "Charger Id": chargerId,
  //         "Charger Name": name,
  //         "Transaction Id": transactionId,
  //         "Date & Time": computeDate(item.startTime) + ", " + computeTime(item.startTime),

  //         "Units Consumed in kWh": computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
  //         "Per Unit Rate": perUnitRate,
  //         "Billed Amount": computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10), perUnitRate),
  //         "Received Amount": computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10), perUnitRate),
  //       };
  //     });
  //     // Convert JSON to worksheet
  //     const worksheet = XLSX.utils.json_to_sheet(excelData);

  //     // Create a new workbook
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //     // Trigger Excel file download
  //     XLSX.writeFile(workbook, "my-data.xlsx");
  //   } catch (e) {
  //     console.log("Error in downloading report", e);
  //   } finally {
  //     this.setState({ isDownloadLoading: false });
  //   }
  // };
  render() {
    const data = this.getMemoizedData();

    return (
      <React.Fragment>
        <div className="page-content" onClick={()=>this.state.isReportDownload && this.setState({isReportDownload:false})}>
          <ReactModal isOpen={this.state.isShowUserEmailModal} onRequestClose={this.closeIsShowUserEmailModal} style={modalStyle("50%", "50%")}>
            <div style={{ padding: "20px" }}>
              <div style={styles.modalHeader}>
                <div>
                  <h4 className="card-title">Email (Mandatory)</h4>
                  <p className="card-title-desc">Fill all information below to send Invoice in Mail</p>
                </div>
                <h1>
                  <img src={LKCloseImg} alt="Close" style={styles.closeReactStrapModal} onClick={this.closeIsShowUserEmailModal} />

                  {/* <i className="ri-close-line" style={styles.closeReactStrapModal} onClick={this.closeIsShowUserEmailModal}></i> */}
                </h1>
              </div>

              <Row>
                <Col>
                  <FormGroup>
                    <Label htmlFor="userEmail">User Email{inputRequired()}</Label>
                    <Input
                      id="userEmail"
                      name="userEmail"
                      type="email"
                      className="form-control"
                      placeholder="Enter User mail id"
                      value={this.state.selectedUserEmail}
                      onChange={(e) => this.setState({ selectedUserEmail: e.target.value })}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-center mt-4">
                <ActiveBtn
                  name={"Send Mail"}
                  handleClick={async () => {
                    this.closeIsShowUserEmailModal();
                    this.handleMailInvoice();
                  }}
                />

                <CancelBtn
                  name={"Cancel"}
                  handleClick={() => {
                    this.closeIsShowUserEmailModal();
                  }}
                />
              </div>
            </div>
          </ReactModal>
          <Container fluid>
            <Breadcrumbs title="Orders" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col lg={12}>
                <Card>
                  <Modal
                    isOpen={this.state.isDownloadLoading}
                    contentLabel="Map Modal"
                    // onAfterOpen={handleModalOpen} // Trigger resize when modal opens
                    style={styles.modalStyle}
                  >
                    <Spinner />
                  </Modal>
                  <CardBody className="pt-0">
                    <Nav tabs className="nav-tabs-custom mb-4">
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab("1");
                          }}
                          className={classnames({ active: this.state.activeTab === "1" }, "font-weight-bold p-3")}
                        >
                          All Orders
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab("2");
                          }}
                          className={classnames({ active: this.state.activeTab === "2" }, "p-3 font-weight-bold")}
                        >
                          Paid
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab("3");
                          }}
                          className={classnames({ active: this.state.activeTab === "3" }, " p-3 font-weight-bold")}
                        >
                          Refund
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab("4");
                          }}
                          className={classnames({ active: this.state.activeTab === "4" }, "p-3 font-weight-bold")}
                        >
                          OnGoing
                        </NavLink>
                      </NavItem>
                      <div style={{ position: "absolute", top: "16px", right: "2%", zIndex: 20 }}>
                        <Label
                          style={{ cursor: "pointer", marginBottom: "15px",color:"#005C8E" }}
                          onClick={(e) =>{
                            e.stopPropagation()
                            this.setState((prevState) => ({
                              isReportDownload: !prevState.isReportDownload,
                            }))}
                          }
                        >
                          Download
                        </Label>
                        {
                          this.state.isReportDownload && <DropDown
                          options={downloadData}
                          selectedOption={"selectedFiltered"}
                          onSelect={(optionSelected) => {
                            if (optionSelected?.value === "pdf") {
                              this.handleDownloadReportInPDF();
                            } else if (optionSelected?.value === "excel") {
                              // this.exportToExcel();

                            }
                          }}
                        />
                        }
                       
                      </div>
                    </Nav>
                    {this.state.isLoading ? (
                      <div style={{ height: "300px" }}>
                        <Spinner />
                      </div>
                    ) : (
                      <MDBDataTable responsive paging={true} data={data} style={{ textAlign: "center" }} className="mt-4" />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const styles = {
  loaderContainer: { height: "250px" },
  modalStyle: {
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.3)" },
    content: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      padding: "15px",
      borderRadius: "10px",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
    },
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    marginBottom: "20px",
  },
  closeReactStrapModal: { cursor: "Pointer", width: "20px", height: "20px", marginLeft: "auto" },
};
const mapStateToProps = (state) => ({
  chargerIds: state?.ChargerManagement?.chargerIds,
  locationIds: state.LocationManagement.locationIds,
  user: state?.Login?.user,
});
const mapDispatchToProps = (dispatch) => ({
  chargerSelected: (payload) => dispatch(chargerSelected(payload)),
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Orders);
